<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-18 18:17:31
-->
<template>
  <veStuLiteraryProgram viewType="admin" slot="table"></veStuLiteraryProgram>
</template>

<script>
import veStuLiteraryProgram from './base/veStuLiteraryProgram';
export default {
  components: {
    veStuLiteraryProgram
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
